import { motion, useInView, Variants } from 'framer-motion'
import { ComponentChildren } from 'preact'
import { Ref } from 'preact/hooks'

interface StickyPanelProps {
  children: ComponentChildren
  watch: Ref<HTMLDivElement>
}

export function StickyPanel({ children, watch }: StickyPanelProps) {
  const isInView = useInView(watch)

  const variants: Variants = {
    out: { y: '-100%' },
    in: { y: 0 },
  }

  return (
    <div className="fixed left-0 z-30 block w-full h-0 pointer-events-none -top-8 sm:overflow-clip">
      <motion.div
        className="w-full pointer-events-auto sm:pointer-events-none -translate-y-full"
        initial="out"
        animate={isInView ? 'out' : 'in'}
        variants={variants}>
        {!isInView && children}
      </motion.div>
    </div>
  )
}
